import {
  MOVE_PREP_CATEGORIES,
  MOVE_PREP_TASKS,
} from '../../_defaults/move-prep-catalog'
import { MovePrepTask } from '../../_types/move-prep'
import { CategoryGroup } from './types'

/**
 * Builds the per-category grouping the checklist UI renders, with a
 * pre-computed completed-count for each group's progress chip.
 *
 * @param {Record<string, number>} completions - profile.movePrepCompletions
 * @returns {CategoryGroup[]} the grouped + counted categories
 */
const buildCategoryGroups = (
  completions: Record<string, number>,
): CategoryGroup[] => {
  return MOVE_PREP_CATEGORIES.map(descriptor => {
    const tasks: MovePrepTask[] = MOVE_PREP_TASKS.filter(
      task => task.category === descriptor.category,
    )
    const completedCount = tasks.reduce(
      (count, task) => count + ((completions[task.id] ?? 0) > 0 ? 1 : 0),
      0,
    )
    return {
      label: descriptor.label,
      glyph: descriptor.glyph,
      blurb: descriptor.blurb,
      tasks,
      completedCount,
    }
  })
}

/**
 * Returns the overall completion percent (0–100) across every task.
 *
 * @param {Record<string, number>} completions - profile.movePrepCompletions
 * @returns {number} the overall percent complete, rounded
 */
const computeOverallPercent = (completions: Record<string, number>): number => {
  if (MOVE_PREP_TASKS.length === 0) {
    return 0
  }
  const completed = MOVE_PREP_TASKS.reduce(
    (count, task) => count + ((completions[task.id] ?? 0) > 0 ? 1 : 0),
    0,
  )
  return Math.round((completed / MOVE_PREP_TASKS.length) * 100)
}

export { buildCategoryGroups, computeOverallPercent }
